module.exports = __webpack_public_path__ + "media/img/amara-e80f3ca868f94885c08efbf97c557df3.png";